import { createSelector } from '@reduxjs/toolkit';
import * as fromContext from 'app/reducers/context.reducer';
import { AuthState, TokenInfo } from 'app/reducers/context.reducer';
import { ADMINISTRATOR, SUPER_MANAGER, MANAGER, SUPPORT, USER, VERSIONS_EDITOR_EMAIL_WHITELIST, } from "app/config";
import { createFeatureSelector } from "@ngrx/store";

export interface RoleMembership {
  isUser: boolean;
  isManager: boolean;
  isSuperManager: boolean;
  isSupport: boolean;
  isAdministrator: boolean;
  isVersionsEditor: boolean;
}

const selectSelf = createFeatureSelector<AuthState>(fromContext.AuthFeatureKey);

export const selectTokenInfo = createSelector(
  selectSelf,
  (state): TokenInfo | null => {
    return state.tokenInfo;
  }
);

export const selectIsAuthenticated = createSelector(
  selectSelf,
  (state): boolean => {
    return !!(state.tokenInfo && state.tokenInfo.tokenExpires > new Date());
  }
);

export const selectLanguage = createSelector(
  selectSelf,
  (state) => {
    return state.language;
  }
);

export const selectLoginData = createSelector(
  selectSelf,
  (state) => {
    return state.loginData;
  }
);

export const selectRole = createSelector(
  selectLoginData,
  (loginData): RoleMembership => {

    const isAdministrator = !!(loginData && loginData.roles.find(r => r === ADMINISTRATOR));
    const isSupport = isAdministrator || !!(loginData && loginData.roles.find(r => r === SUPPORT))
    const isSuperManager = isAdministrator || isSupport || !!(loginData && loginData.roles.find(r => r === SUPER_MANAGER))
    const isManager = isAdministrator || isSupport || isSuperManager || !!(loginData && loginData.roles.find(r => r === MANAGER))
    const isUser = isAdministrator || isSupport || isSuperManager || isManager || !!(loginData && loginData.roles.find(r => r === USER))

    const email = (loginData?.email ?? '').toLowerCase().trim();
    const isVersionsEditor = VERSIONS_EDITOR_EMAIL_WHITELIST.has(email);

    return {
      isUser,
      isSuperManager,
      isManager,
      isSupport,
      isAdministrator,
      isVersionsEditor,
    };
  }
);

export const selectCanEditVersions = createSelector(
  selectRole,
  (roles) => roles.isVersionsEditor
);

export const selectIfManager = createSelector(
  selectRole,
  (roles) => {
    return roles.isAdministrator || roles.isManager || roles.isSupport
  }
);

export const selectIfAdministrator = createSelector(
  selectRole,
  (roles) => {
    return roles.isAdministrator
  }
);

export const selectIfSupport = createSelector(
  selectRole,
  (roles) => {
    return roles.isAdministrator || roles.isSupport
  }
);
